import { render, staticRenderFns } from "./LeadsDrilldownTable.vue?vue&type=template&id=2139e652&scoped=true&"
import script from "./LeadsDrilldownTable.vue?vue&type=script&lang=js&"
export * from "./LeadsDrilldownTable.vue?vue&type=script&lang=js&"
import style0 from "./LeadsDrilldownTable.vue?vue&type=style&index=0&id=2139e652&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2139e652",
  null
  
)

export default component.exports